<template>
  <div class="" id="goods">
    <div class="top">
      <NavTop activeIndex="3"></NavTop>
    </div>
    <div
      class=""
      style="
        width: 1000px;
        margin: 100px auto 0;
        min-height: 600px;
        background-color: #fff;
        padding: 30px 60px;
      "
    >
      <div class="" style="font-size: 28px; font-weight: bold">意见反馈</div>
      <div
        class=""
        style="
          display: flex;
          align-items: center;
          margin-top: 30px;
          margin-bottom: 20px;
        "
      >
        <div class="" style="font-size: 20px">反馈类型</div>
        <div
          :class="current == index ? 'active' : ''"
          v-for="(item, index) in list"
          :key="index"
          style="
            width: 74px;
            height: 28px;
            border-radius: 60px;
            background-color: #e8e8e8;
            color: #fff;
            text-align: center;
            line-height: 28px;
            margin-left: 20px;
          "
          @click="current = index"
        >
          {{ item }}
        </div>
      </div>
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="textarea"
        maxlength="500"
        autosize
        show-word-limit
      >
      </el-input>
      <div class="" style="font-size: 18px; margin-top: 20px">
        联系方式(QQ,SKYPE,email):
      </div>
      <div class="" style="border: 1px solid #ddd; border-radius: 5px">
        <el-input
          v-model="phone"
          placeholder="方便我们的工作人员尽快联系您"
        ></el-input>
      </div>
      <el-upload
        class="upload-demo"
        action="https://476.new.lingchuang.co/api/common/upload"
        :on-success="onSuccess"
        multiple
        :limit="3"
        :on-exceed="handleExceed"
        :headers="headers"
        :file-list="fileList"
        :on-remove="onRemove"
        :show-file-list="false"
      >
        <div
          class=""
          style="display: flex; align-items: center; margin-top: 30px"
        >
          <div
            class=""
            style="
              width: 80px;
              height: 80px;
              border: 1px solid #ddd;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 5px;
              margin-right: 20px;
            "
          >
            <i class="el-icon-plus" style="font-size: 40px; color: #ddd"></i>
          </div>
          <div slot="tip" class="el-upload__tip">
            仅支持上传 .png .jpg .gif格式的文件
          </div>
        </div>
      </el-upload>
      <div
        class=""
        style="display: flex; align-items: center; margin-top: 20px"
      >
        <div
          class=""
          v-for="(item, index) in fileList"
          :key="index"
          style="width: 50px; border-radius: 5px; margin-right: 10px"
        >
          <img
            :src="item.response.data.fullurl"
            alt=""
            style="width: 50px; height: 50px; border-radius: 5px"
          />
        </div>
      </div>
      <div
        class=""
        style="
          width: 142px;
          height: 34px;
          background-color: #efefef;
          text-align: center;
          line-height: 34px;
          border-radius: 5px;
          margin-top: 30px;
        "
        @click="submit"
      >
        提交
      </div>
    </div>
  </div>
</template>
<script>
import NavTop from "../components/NavTopWhit.vue";

import { subFeedList } from "../api/user";
export default {
  components: {
    NavTop,
  },
  data() {
    return {
      list: ["建议", "错误", "其他"],
      current: 0,
      textarea: "",
      phone: "",
      fileList: [],
      headers: {
        token: localStorage.getItem("token"),
      },
    };
  },
  methods: {
    onSuccess(files, filList) {
      console.log(files, filList);
      this.fileList.push(filList);
      // this.fileList.push(e.data.fullurl)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    onRemove(files, filList) {
      console.log(files, filList);
      this.fileList = filList;
    },
    submit() {
      console.log(
        this.list[this.current],
        this.textarea,
        this.phone,
        this.fileList
      );
      var arr = [];
      this.fileList.forEach((item) => {
        arr.push(item.response.data.fullurl);
      });
      let str = arr.join(",");
      subFeedList({
        type: this.current + 1,
        content: this.textarea,
        contact: this.phone,
        image: str,
      }).then((res) => {
        this.notifySucceed("提交成功");
      });
    },
  },
};
</script>
<style>
.active {
  background-color: #4b72f6 !important;
}
</style>
